import * as React from "react";
import Header from "../components/Header";
import Copy from "../components/Copy";
import ImageGallery from "../components/ImageGallery";
import Contact from "../components/Contact";

const Index: React.FC<{}> = () => (
  <>
    <Header />
    <Copy>
      <h3>UNDER CONSTRUCTION</h3>
      <p>In the meantime: Look what we’ve got cooking:</p>
      <p>
        Suzi’s Specialties - a mother-daughter business that came into existence
        to share their family’s favorites recipes.
      </p>
      <p>
        Mission: To provide our customers with a unique and savory food
        experience.
      </p>
      <p>
        Suzi’s Specialties is proud of its debut product: the spinach pie that
        is not your grandmother’s traditional spanakopita. These spinach pies
        have been tastefully tweaked to provide a delicious savory experience.
        Even the shapes have their differences – ask us about them.
      </p>
      <p>
        We want you to enjoy them as much as our family and friends have over the
        years.
      </p>
    </Copy>
    <ImageGallery />
    <Contact />
  </>
);

export default Index;
